import type { CSSProperties } from 'react';

/**
 * Props of a calendar event box filled with a data hue (a reservation type, a routine event, a payment type). The fill is the
 * pastel `--<hue>-100` in light and a dark tint of `--<hue>-500` in dark (`.rbc-event.data-fill`, _react-big-calendar.scss),
 * and the text inside uses the --on-fill-* tokens of the theme (the `on-data-fill` mixin).
 */
export const dataFillProps = (hue: string, style: CSSProperties = {}): { className: string; style: CSSProperties } => ({
  className: 'data-fill',
  style: { '--data-fill': `var(--${hue}-100)`, '--data-hue': `var(--${hue}-500)`, ...style } as CSSProperties,
});
